module.exports = __webpack_public_path__ + "img/illu2.59f7c54a.png";